/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconEqualNot = createReactComponent("equal-not", "IconEqualNot", [
  ["path", { d: "M5 10h14", key: "svg-0" }],
  ["path", { d: "M5 14h14", key: "svg-1" }],
  ["path", { d: "M5 19l14 -14", key: "svg-2" }]
]);

export { IconEqualNot as default };
//# sourceMappingURL=IconEqualNot.js.map
